import { render, staticRenderFns } from "./DealList.vue?vue&type=template&id=ec3e8b4e&scoped=true&"
import script from "./DealList.vue?vue&type=script&lang=js&"
export * from "./DealList.vue?vue&type=script&lang=js&"
import style0 from "./DealList.vue?vue&type=style&index=0&id=ec3e8b4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3e8b4e",
  null
  
)

export default component.exports